import React from "react";
import { Link } from "react-router-dom";

function NotFoundPage() {
  return (
    <div className="login-page">
      <div className="content-card form-card text-center" style={{ maxWidth: 520 }}>
        <p className="page-eyebrow">Not found</p>
        <h2 className="mb-3">This page does not exist.</h2>
        <p className="text-muted mb-4">The page you requested could not be found in the current frontend workspace.</p>
        <Link className="btn btn-primary" to="/">
          Back to dashboard
        </Link>
      </div>
    </div>
  );
}

export default NotFoundPage;
